import { environment } from '@env/environment';
import type { ServerAccess } from '@core/access/server-access';

import { http } from './http';

/**
 * The caller's resolved access from `GET /api/v1/me`. Resolves `null` when the
 * endpoint is not deployed yet or fails, so the portal falls back to the
 * claim-derived roles rather than locking everyone out during the rollout.
 */
export async function fetchServerAccess(signal?: AbortSignal): Promise<ServerAccess | null> {
  try {
    return await http<ServerAccess>(`${environment.apiConfig.uri.replace(/\/$/, '')}/api/v1/me`, { signal });
  } catch {
    return null;
  }
}
